export default [
  {
    path: "/piarequest",
    name: "PIARequest",
    component: () => import("@/views/Page/PIARequest/PIARequest.vue"),
    meta: {
      title: "#Default# | PIARequest",
    },
  },
  {
    path: "/piarequest/:id",
    name: "piarequestdetails",
    component: () => import("@/views/Page/PIARequest/PIARequestDetails.vue"),
    meta: {
      title: "#Default# | PIARequest",
    },
  },
];
